module.exports = __webpack_public_path__ + "static/media/videos.60930177.svg";